import { EyeIcon, FolderIcon } from '@prophecy/icons';
import { theme } from '@prophecy/theme';
import { Button, Stack } from '@prophecy/ui-v3';
import React, { useState } from 'react';

import { PsetContent } from '../../components/PsetContent';
import { EntityErrorType } from '../../types';
import { StyledChevronRightIcon, StyledInput } from '../styled';
import { FileTypes } from '../types';
import { FolderLabels, getEntityErrorTitle } from '../utils';
import { TranspilerFileBrowser } from './TranspilerFileBrowser';

export const EntityFileAndName = ({
  type,
  targetName,
  filePathValue = '',
  targetValue = '',
  onChange,
  sourceLabel,
  error,
  disabled = false
}: {
  type: FileTypes;
  error?: EntityErrorType;
  targetName: string;
  targetValue?: string;
  filePathValue?: string;
  onChange: (value: string, key: string) => void;
  actions?: React.ReactNode;
  sourceLabel?: string;
  disabled?: boolean;
}) => {
  const label = sourceLabel || `${FolderLabels[type as keyof typeof FolderLabels]} (*.${type} file)`;
  const [hasFileBrowser, toggleBrowser] = useState(false);
  const hasError = error?.error || error?.duplicate;
  const [targetPath, setTargetPath] = useState('');
  return (
    <Stack
      direction='horizontal'
      alignY='center'
      padding={`0 0 ${theme.spaces.x12}`}
      width='100%'
      gap={theme.spaces.x16}
      align='space-between'>
      {hasFileBrowser && !disabled && (
        <TranspilerFileBrowser
          extension={type}
          selectedPath={filePathValue}
          onChange={(value) => onChange(value, 'filePath')}
          toggleFilePath={() => toggleBrowser(false)}
        />
      )}
      {targetPath && filePathValue && <PsetContent path={targetPath} onClose={() => setTargetPath('')} />}
      <StyledInput
        addOnPlacement='right'
        value={filePathValue}
        label={label}
        disabled={disabled}
        addOn={
          disabled ? null : (
            <Button
              onClick={() => toggleBrowser(true)}
              variant='tertiaryGray'
              size='s'
              icon={<FolderIcon type='default' size='xs' />}
              aria-label='Open file browser'
              data-test-id='entity-file-and-name-open-file-browser-button'
            />
          )
        }
        icon={filePathValue ? <EyeIcon type='default' onClick={() => setTargetPath(filePathValue)} /> : null}
        onChange={(value) => onChange(value, 'filePath')}
        data-test-id='entity-file-and-name-file-path-input'
      />
      <StyledChevronRightIcon type='default' color={theme.colors.gray600} />
      <StyledInput
        disabled={disabled}
        tooltip={getEntityErrorTitle(error)}
        value={targetValue}
        label={targetName}
        variant={targetValue && !hasError ? 'primary' : 'error'}
        onChange={(value) => onChange(value, 'name')}
        data-test-id='entity-file-and-name-target-name-input'
      />
    </Stack>
  );
};
